// import { Component } from '@angular/core';
// import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
// import { ActivatedRoute } from '@angular/router';

// @Component({
//   selector: 'app-test-payment-gateway',
//   templateUrl: './test-payment-gateway.component.html',
//   styleUrls: ['./test-payment-gateway.component.scss'],
// })
// export class TestPaymentGatewayComponent extends BaseCtl {
//   appId: any = 0;
//   constructor(serviceLocator: ServiceLocatorService, route: ActivatedRoute) {
//     // Pass the endpoint and services to BaseCtl
//     super('endpoint.payment', serviceLocator, route);
//     let _self = this;
//     _self.appId = Number(this.route.snapshot.paramMap.get('appId'));
//     if (_self.appId) {
//       this.getPaymentGateways();
//     }
//   }

//   gateways: any = [];
//   paymentConfigForm = {
//     data: {
//       gatewayName: '',
//       apiKey: '',
//       apiSecret: '',
//       merchantId: '',
//       mode: '',
//       callbackUrl: '',
//       appId: '',
//       isActive: 0,
//     },
//   };
//   testPaymentData = {
//     amount: 1,
//   };
//   getPaymentGateways(): void {
//     let _self = this;
//     let searchData = {
//       appId: this.appId,
//     };

//     _self.locator.config
//       .getProperty('endpoint.payment')
//       .then((property: string) => {
//         let url = property + '/search/0';
//         const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
//         let sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

//         if (url) {
//           url += ';jsessionid=' + sid;
//         }
//         _self.locator.http.post(
//           url,
//           searchData,
//           function (res: any, error: boolean) {
//             if (error) {
//               alert('Server Error:' + error);
//               return;
//             }

//             _self.gateways = res.result['data'];
//           }
//         );
//       });
//   }

//   onEdit(id: any) {
//     this.forward('paymentconfiguration/' + this.appId + '/' + id);
//   }

//   getPaymentGatewaysInfo(id: any, callback?: () => void) {
//     let _self = this;

//     _self.locator.config
//       .getProperty('endpoint.payment')
//       .then((property: string) => {
//         let url = property + '/get/' + id;

//         const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
//         let sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

//         if (url) {
//           url += ';jsessionid=' + sid;
//         }
//         _self.locator.http.get(url, function (res: any, error: boolean) {
//           if (error) {
//             alert('Server Error:' + error);
//             return;
//           }

//           const result = res.result?.data;
//           if (!result) {
//             console.error('No data returned for rule');
//             return;
//           }

//           _self.paymentConfigForm = { data: result };

//           if (callback) callback();
//         });
//       });
//   }

//   /**
//    * Delete jasper report
//    */
//   deleteJasper(id: any) {
//     let _self = this;

//     if (!confirm('Are you sure you want to delete this report?')) return;

//     _self.locator.config
//       .getProperty('endpoint.payment')
//       .then((property: string) => {
//         let url = property + `/delete/${id}`;
//         const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
//         let sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

//         if (url) {
//           url += ';jsessionid=' + sid;
//         }
//         _self.locator.http.get(url, function (res: any, error: any) {
//           if (error) {
//             alert('Delete failed: ' + error);
//             return;
//           }

//           _self.form.message = 'Deleted Successfully';
//           _self.form.success = true;

//           // Refresh reports
//           _self.getPaymentGateways();
//         });
//       });
//   }

//   confirmTestPayment() {
//     if (!this.paymentConfigForm.data.gatewayName) {
//       alert('Please select a payment gateway!');
//       return;
//     }

//     switch (this.paymentConfigForm.data.gatewayName) {
//       case 'Razorpay':
//         this.startRazorpayPayment(this.testPaymentData.amount);
//         break;
//       case 'PAYTM':
//         // this.startPaytmPayment(this.testPaymentData.amount);
//         break;
//       case 'PAYU':
//         // this.startPayUPayment(this.testPaymentData.amount);
//         break;
//       default:
//         alert('Payment gateway not configured.');
//     }
//   }

//   // startRazorpayPayment(amount: number) {
//   //   // this.loadRazorpayScript().then(() => {
//   //   //   this.paymentService.getKey().subscribe((key: string) => {
//   //   //     this.paymentService.createOrder(amount).subscribe((order: any) => {
//   //   //       const options = {
//   //   //         key,
//   //   //         amount: order.amount,
//   //   //         currency: 'INR',
//   //   //         name: 'My Test App',
//   //   //         description: 'Test Transaction',
//   //   //         order_id: order.id,
//   //   //         handler: (response: any) => {
//   //   //           alert(
//   //   //             '✅ Payment Successful!\nPayment ID: ' +
//   //   //               response.razorpay_payment_id
//   //   //           );
//   //   //         },
//   //   //         prefill: {
//   //   //           name: 'Test User',
//   //   //           email: 'test@example.com',
//   //   //           contact: '9876543210',
//   //   //         },
//   //   //         theme: { color: '#3399cc' },
//   //   //       };
//   //   //       const rzp = new (window as any).Razorpay(options);
//   //   //       rzp.on('payment.failed', (response: any) => {
//   //   //         alert('❌ Payment Failed!\nReason: ' + response.error.description);
//   //   //       });
//   //   //       rzp.open();
//   //   //     });
//   //   //   });
//   //   // });
//   // }
//   private loadRazorpayScript(): Promise<void> {
//     return new Promise((resolve, reject) => {
//       if ((window as any).Razorpay) {
//         resolve();
//         return;
//       }
//       const script = document.createElement('script');
//       script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//       script.onload = () => resolve();
//       script.onerror = () => reject('Razorpay SDK failed to load.');
//       document.body.appendChild(script);
//     });
//   }

//   startRazorpayPayment(amount: number) {
//     let _self = this;

//     // Get the payment endpoint from config
//     _self.locator.config
//       .getProperty('endpoint.payment')
//       .then((property: string) => {
//         let url = property + 'create';

//         const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
//         let sid = localStorage.getItem(keySuffix + 'sessionId') || '0';

//         if (url) {
//           url += ';jsessionid=' + sid;
//         }

//         // Call backend to create order
//         _self.locator.http.get(url, (res: any, error: boolean) => {
//           if (error) {
//             alert('Server Error:' + error);
//             return;
//           }

//           // Assuming backend returns JSON with amount etc.
//           const data = res.result.clientOptions;

//           const options = {
//             key: 'rzp_test_R7sertjdDVHKzN',
//             amount: Number(data.amount) * 100, // paise
//             currency: data.currency,
//             name: 'My Test App',
//             description: 'Test Transaction',
//             order_id: data.orderId,
//             handler: (response: any) => {
//               // Use arrow function to preserve this context
//               _self.locator.http.post(
//                 property + 'verify',
//                 response,
//                 (verifyRes: any, err: boolean) => {
//                   if (err) {
//                     alert('Verification error: ' + err);
//                     return;
//                   }
//                   if (verifyRes.result) {
//                     alert('✅ Payment Verified Successfully!');
//                   } else {
//                     alert('❌ Payment Verification Failed!');
//                   }
//                 }
//               );
//             },
//             prefill: {
//               name: 'Test User',
//               email: 'test@example.com',
//               contact: '9876543210',
//             },
//             theme: { color: '#3399cc' },
//           };

//           const rzp = new (window as any).Razorpay(options);
//           rzp.on('payment.failed', (response: any) => {
//             alert('❌ Payment Failed!\nReason: ' + response.error.description);
//           });
//           rzp.open();
//         });
//       });
//   }
// }
import { Component, ElementRef, ViewChild } from '@angular/core';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { ActivatedRoute } from '@angular/router';
declare var bootstrap: any;
@Component({
  selector: 'app-test-payment-gateway',
  templateUrl: './test-payment-gateway.component.html',
  styleUrls: ['./test-payment-gateway.component.scss'],
})
export class TestPaymentGatewayComponent extends BaseCtl {
  @ViewChild('testPaymentModal') testPaymentModal!: ElementRef;
  appId: number = 0;
  gateways: any[] = [];
  paymentConfigForm = {
    data: {
      gatewayName: '',
      apiKey: '',
      apiSecret: '',
      merchantId: '',
      mode: '',
      callbackUrl: '',
      appId: '',
      isActive: 0,
      id: 0,
    },
  };
  testPaymentData = { amount: 1 };

  constructor(serviceLocator: ServiceLocatorService, route: ActivatedRoute) {
    super('endpoint.payment', serviceLocator, route);
    this.appId = Number(this.route.snapshot.paramMap.get('appId'));
    if (this.appId) this.getPaymentGateways();
  }

  /** Centralized URL builder with JSESSIONID */
  private async getUrl(path: string): Promise<string> {
    const property = await this.locator.config.getProperty('endpoint.payment');
    const keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const sid = localStorage.getItem(keySuffix + 'sessionId') || '0';
    return `${property}${path};jsessionid=${sid}`;
  }

  /** Load Razorpay SDK */
  private loadRazorpayScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).Razorpay) return resolve();
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve();
      script.onerror = () => reject('Razorpay SDK failed to load.');
      document.body.appendChild(script);
    });
  }

  /** Fetch payment gateways */
  async getPaymentGateways(): Promise<void> {
    try {
      const url = await this.getUrl('/search/0');
      const searchData = {
        appId: this.appId,
      };
      this.locator.http.post(url, searchData, (res: any, error: boolean) => {
        if (error) return alert('Server Error: ' + error);
        this.gateways = res.result?.data || [];
      });
    } catch (err) {
      console.error('Error fetching gateways:', err);
    }
  }

  /** Get single gateway info */
  async getPaymentGatewaysInfo(id: any, callback?: () => void): Promise<void> {
    try {
      const url = await this.getUrl(`/get/${id}`);
      this.locator.http.get(url, (res: any, error: boolean) => {
        if (error) return alert('Server Error: ' + error);
        const result = res.result?.data;
        if (!result) return console.error('No data returned for gateway');
        this.paymentConfigForm = { data: result };
        if (callback) callback();
      });
    } catch (err) {
      console.error('Error fetching gateway info:', err);
    }
  }

  /** Delete gateway */
  async deleteJasper(id: any): Promise<void> {
    if (!confirm('Are you sure you want to delete this report?')) return;
    try {
      const url = await this.getUrl(`/delete/${id}`);
      this.locator.http.get(url, (res: any, error: boolean) => {
        if (error) return alert('Delete failed: ' + error);
        this.form.message = 'Deleted Successfully';
        this.form.success = true;
        this.getPaymentGateways();
      });
    } catch (err) {
      console.error('Error deleting gateway:', err);
    }
  }

  /** Confirm test payment */
  // confirmTestPayment(): void {
  //   if (!this.paymentConfigForm.data.gatewayName) {
  //     return alert('Please select a payment gateway!');
  //   }

  //   const gatewayMap: any = {
  //     Razorpay: this.startRazorpayPayment.bind(this),
  //     PAYTM: (amount: number) => console.warn('PAYTM not implemented'),
  //     PAYU: (amount: number) => console.warn('PAYU not implemented'),
  //   };

  //   const handler = gatewayMap[this.paymentConfigForm.data.gatewayName];
  //   if (handler) handler(this.testPaymentData.amount);
  //   else alert('Payment gateway not configured.');
  // }
  confirmTestPayment() {
    if (!this.paymentConfigForm.data.gatewayName) {
      alert('Please select a payment gateway!');
      return;
    }
    const modalEl = this.testPaymentModal.nativeElement;
    const modal =
      bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
    modal.hide();
    switch (this.paymentConfigForm.data.gatewayName) {
      case 'Razorpay':
        this.startRazorpayPayment(this.testPaymentData.amount);
        break;
      case 'PAYTM':
        // this.startPaytmPayment(this.testPaymentData.amount);
        break;
      case 'PAYU':
        // this.startPayUPayment(this.testPaymentData.amount);
        break;
      default:
        alert('Payment gateway not configured.');
    }
  }
  /** Start Razorpay payment */
  // async startRazorpayPayment(amount: number): Promise<void> {
  //   try {
  //     await this.loadRazorpayScript();
  //     const url = await this.getUrl('/createTest');
  //     const payload = {
  //       appId: this.appId,
  //       amount: this.testPaymentData.amount,
  //       id: this.paymentConfigForm.data.id,
  //     };
  //     this.locator.http.post(url, payload, (res: any, error: boolean) => {
  //       if (error) return alert('Server Error: ' + error);
  //       const data = res.result?.clientOptions;
  //       if (!data) return alert(`${res.result.message}`);

  //       const options = {
  //         key: data.key,
  //         amount: Number(data.amount) * 100,
  //         currency: data.currency,
  //         name: 'My Test App',
  //         description: 'Test Transaction',
  //         order_id: data.orderId,
  //         handler: (response: any) => {
  //            let payload ={...data,...response}
  //             const url =  this.getUrl('/verify');
  //           this.locator.http.post(
  //             url,
  //             response,
  //             (verifyRes: any, err: boolean) => {
  //               if (err) return alert('Verification error: ' + err);
  //               alert(
  //                 verifyRes.result
  //                   ? '✅ Payment Verified Successfully!'
  //                   : '❌ Payment Verification Failed!'
  //               );
  //             }
  //           );
  //         },
  //         prefill: {
  //           name: 'Test User',
  //           email: 'test@example.com',
  //           contact: '9876543210',
  //         },
  //         theme: { color: '#3399cc' },
  //       };

  //       const rzp = new (window as any).Razorpay(options);
  //       rzp.on('payment.failed', (response: any) => {
  //         alert('❌ Payment Failed!\nReason: ' + response.error.description);
  //       });
  //       rzp.open();
  //     });
  //   } catch (err) {
  //     console.error('Razorpay error:', err);
  //     alert(err);
  //   }
  // }
  async startRazorpayPayment(amount: number): Promise<void> {
    try {
      await this.loadRazorpayScript();

      const url = await this.getUrl('/createTest');
      const payload = {
        appId: this.appId,
        amount: this.testPaymentData.amount,
        id: this.paymentConfigForm.data.id,
      };

      this.locator.http.post(url, payload, async (res: any, error: boolean) => {
        if (error) return alert('Server Error: ' + error);

        const data = res.result?.clientOptions;
        console.log(data)
        if (!data) return alert(res.result.message);

        const options = {
          key: data.apiKey,
          amount: Number(data.amount),
          currency: data.currency,
          name: 'My Test App',
          description: 'Test Transaction',
          order_id: data.orderId,
          handler: async (response: any) => {
            // Merge response with context data
            const verifyPayload = { ...data, ...response };

            const verifyUrl = await this.getUrl('/verify');
            this.locator.http.post(
              verifyUrl,
              verifyPayload,
              (verifyRes: any, err: boolean) => {
                if (err) return alert('Verification error: ' + err);

                alert(
                  verifyRes.result
                    ? '✅ Payment Verified Successfully!'
                    : '❌ Payment Verification Failed!'
                );
              }
            );
          },
          prefill: {
            name: 'Test User',
            email: 'test@example.com',
            contact: '9876543210',
          },
          theme: { color: '#3399cc' },
        };

        const rzp = new (window as any).Razorpay(options);

        rzp.on('payment.failed', (response: any) => {
          alert('❌ Payment Failed!\nReason: ' + response.error.description);
        });

        rzp.open();
      });
    } catch (err) {
      console.error('Razorpay error:', err);
      alert(err);
    }
  }

  /** Navigate to edit page */
  onEdit(id: any): void {
    this.forward(`paymentconfiguration/${this.appId}/${id}`);
  }
}
